/* eslint-disable vue/component-name-in-template-casing */
import { IMPROVE_CONFIG } from "@/config.js";
// import dropzoneTemplate from '@/components/global/Dropzone'

const DropzoneConfig = {
  url: `${IMPROVE_CONFIG.API_URL}/nowhere`,
  uploadMultiple: false,
  // previewTemplate: dropzoneTemplate,
  addRemoveLinks: true,
  capture: true,
  params: {},
  maxFiles: 1,
  //dictDefaultMessage: "hello"
};

export default DropzoneConfig;
